<template>
  <div class="list">
    <div class="center" v-if="list.length > 0">
      <div v-for="(item, index) in list" :key="index">
        <div class="box">
          <div class="box-center">
            <div style="flex: 1">
              <p class="title">
                {{ item.empName }}提交"{{
                  optionType[Number(item.pbType) - 1]?.name
                }}"申请
                <span class="tabMarker" @click="toUrl(item)">详情 ></span>
              </p>
              <div class="messageOrBtn">
                <div>
                  {{ item.createTime }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kong_con" v-else>
      <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
      <div class="kong_title kong_title1">暂无审批</div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import apis from "@/apis/publicWelfare";
//   import { downloadExcel } from "@/utils/tools";
export default {
  name: "list",
  props: {
    type: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      list: [],
      form: {
        cardName: "",
        cardId: "",
        point: "",
        senderEmpno: "",
        reciverEmpno: "",
        ccEmpno: [],
        medalId: "",
      },
      isDisabled: false,
      loadingSelect: false,
      options: [],
      optionsKeyword: [],
      showUserBadge: false,
      optionType: [],
    };
  },
  watch: {
    type() {
      this.getList();
    },
  },
  created() {},
  mounted() {
    this.getList();
    this.getSelect();
  },
  methods: {
    //获取提交信息
    getSelect() {
      apis.getTypeList().then((res) => {
        if (res.code == 200) {
          console.log(res, "res");
          this.optionType = res.data;
        }
      });
    },
    //获取列表
    getList() {
      api
        .pubBenefitAdminPersonListListApi({
          state: this.type,
          auditType: 2,
          auditNo: this.type == 4 ? this.$store.state.userInfo.username : "",
        })
        .then((data) => {
          this.list = data.data.list;
          this.list.forEach((item) => {
            item.createTime = this.$moment(item.createTime).format(
              "YYYY-MM-DD"
            );
          });
          console.log(data, "data");
        });
    },
    //跳转公益审批
    toUrl(item) {
      this.$router.push({
        path: "/mobile/medal/publicWelfare/submitWelfareApprove",
        query: {
          id: item.id,
          type: 1,
          apply: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.list {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.center {
  overflow: auto;
  // flex: 1;
  height: calc(100vh - 420px);
  // 去除滚动条
  &::-webkit-scrollbar {
    display: none;
  }
}
.box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 28px;
  margin-bottom: 30px;
  background: #fff;
  border-radius: 40px;
  padding: 30px;
  .box-center {
    display: flex;
    align-items: flex-start;
    width: 100%;
    .img-1 {
      margin-right: 30px;
      width: 40px;
      height: 50px;
    }
    div {
      color: rgba(150, 155, 158, 1);
      // width: 540px;
      // flex: 1;
      p:nth-child(1) {
        color: black;
        font-size: 30px;
        margin-bottom: 10px;
      }
    }
    .title {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .tabMarker {
        flex-shrink: 0;
        display: block;
        font-size: 11px * $zoom;
        margin-left: 20px;
        margin-right: 10px;
        color: #5cdac8;
      }
      .colorYellow {
        background-color: #fff3e8;
        color: #ff8e20;
      }

      .colorRed {
        background-color: #f6eef0;
        color: red;
      }

      .colorGreen {
        background-color: #edf5f2;
        color: #4ea27c;
      }
    }

    .messageOrBtn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
      div:nth-child(2) {
        display: flex;
        align-items: center;
        background: #f2f2f2;
        color: #7d8592;
        padding: 15px;
        border-radius: 10px;
        white-space: nowrap;
      }
    }
  }
  .right_con {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    .huizhang {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 10px;

      img {
        width: 30px;
        height: 40px;
      }
      p {
        font-weight: 400;
        font-size: 22px;
        color: #969b9e;
        flex-shrink: 0;
      }
    }
  }
  .box-right {
    color: rgba(150, 155, 158, 1);
    text-align: center;
    flex-shrink: 0;
    img {
      width: 36px;
      height: 34px;
      margin-top: 5px;
    }
    p {
      font-weight: 400;
      font-size: 22px;
      color: #969b9e;
    }
  }
}
.kong_con {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 150px;
  justify-content: center;
  .kong_img {
    width: 450px;
    height: 450px;
  }
  .kong_title1 {
    margin-top: 30px !important;
  }
  .kong_title {
    color: #999999;
    font-size: 26px;
    margin-top: 10px;
  }
}
.footer {
  ::v-deep {
    .van-button {
      background: rgba(78, 162, 124, 1);
      border-radius: 10px;
      width: 90%;
      margin-left: 5%;
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      margin-bottom: 20px;
      .van-button__text {
        display: flex;
        align-items: center;
      }
      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        margin-top: -4px;
      }
      span {
        display: inline-block;
        color: #fff;
        // margin-bottom: 10px;
        font-size: 30px;
      }
    }
  }
}
.dialog {
  // height: 218px * $zoom;
  padding: 30px;
  .dialog_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 32px;
    color: #282b32;
  }

  .dialog-people {
    margin-bottom: 30px;
  }
  ::v-deep {
    .van-cell::after {
      border: 0;
    }
    .el-input__inner {
      border: 0;
      background: #f7f9fa;
      border-radius: 10px;
    }
  }
  .dialog-reason {
    ::v-deep {
      .van-cell {
        // background: rgba(244, 244, 244, 1);
        display: flex;
        flex-direction: column;
      }

      .van-field__control {
        // height: 200px !important;
      }
      .van-field__value {
        background: rgba(244, 244, 244, 1);
        padding: 20px 20px;
        border-radius: 10px;
        margin-top: 20px;
      }
    }
  }

  ::v-deep {
    .el-input__inner {
      min-height: 22px * $zoom !important;
    }
  }

  .cc {
    ::v-deep {
      .el-select__tags {
        max-width: none !important;
      }

      .el-input__suffix {
        display: none;
      }
    }
  }

  .dialog-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 30px;
    width: 100%;

    button {
      width: 200px;
      height: 80px;
      border-radius: 40px;
      font-size: 28px;
    }
  }
}
</style>
